/** @format */

import {
	HomefieldButtonModule,
	HomefieldSidePanelModule,
	HomefieldStickyBannerModule,
	HomefieldTextLinkModule
} from '@homefield';
import {
	HomefieldIconLibraryModule,
	HomefieldIconsLibraryService,
	homefieldIconBrandingDsgMono,
	homefieldIconChainLink,
	homefieldIconNikeLogo,
	homefieldIconNikeMember,
	homefieldIconNikeShoe,
	homefieldIconRewards
} from '@dsg-tech/homefield-angular-icons';

import { AlertMessageModule } from '@dcsg-ngx-ecommerce/common/component/alert-message/alert-message.module';
import { CommonModule } from '@angular/common';
import { DcsgNgxEcommerceCommonModule } from '@dcsg-ngx-ecommerce/common';
import { ExclusiveProductPanelComponent } from './exclusive-product-panel.component';
import { NgModule } from '@angular/core';

@NgModule({
	declarations: [ExclusiveProductPanelComponent],
	imports: [
		AlertMessageModule,
		CommonModule,
		DcsgNgxEcommerceCommonModule,
		HomefieldButtonModule,
		HomefieldIconLibraryModule,
		HomefieldSidePanelModule,
		HomefieldStickyBannerModule,
		HomefieldTextLinkModule
	],
	exports: [ExclusiveProductPanelComponent]
})
export class ExclusiveProductPanelModule {
	constructor(homefieldIconsLibraryService: HomefieldIconsLibraryService) {
		homefieldIconsLibraryService.registerIcons([
			homefieldIconNikeLogo,
			homefieldIconBrandingDsgMono,
			homefieldIconChainLink,
			homefieldIconNikeShoe,
			homefieldIconNikeMember,
			homefieldIconRewards
		]);
	}
}
